<template>
  <div class="caseList">
    <viewHeader :keywords="keyword" @normalSearch="normalSearch"></viewHeader>
    <div class="content">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix header-box">
          <img src="../assets/img/icon0.png" alt="" class="L" />
          <span class="L">{{ keyword }}</span>
          <el-button v-if="hasData" class="R" style="padding: 3px 0" type="text" @click="analysis">病例总结</el-button>
        </div>
        <div class="resultTtle">
          <p class="pointData el-icon-warning-outline" v-if="preNumFound === 0 && totalNum !== 0">
            未找到匹配的病例，推荐您阅读以下相关病例
          </p>
          <div class="totalnum-box">
            <p class="totalnum-case">共为您找到<span>{{ totalNum || 0 }}</span>份病例</p>
            <div class="filter-list">
              <span class="L sort_sp">排序：</span>
              <el-select
                v-model="sortText"
                placeholder="请选择"
                size="small"
                @change="handleCommandSort"
                class="L"
            >
                <el-option
                v-for="(item, index) in sort"
                :key="index"
                :label="item"
                :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-box">
            <!-- <div class="filter-list disease-keywords-box">
              <span class="el-dropdown-link">关键词：</span>
              <div class="keywords-box">
                <el-select class="type-select" size="small" v-model="diseaseTypeValue" placeholder="请选择"
                  @change="handleChangeDiseaseType">
                  <el-option :value="item" :label="item" v-for="item in diseaseType" :key="item">
                    {{ item }}
                  </el-option>
                </el-select>
                <el-select class="search-select" size="small" v-model="diseaseWords" placeholder="请输入关键词" filterable
                  clearable multiple collapse-tags remote :remote-method="getDiseaseWords">
                  <el-option v-for="(item, index) in diseaseWordsList" :key="item + '-' + index" :label="item" :value="item" />
                </el-select>
              </div>
              <el-button class="filterKeyWord" @click="handleSelectWords">过滤</el-button>
            </div> -->
            <div class="filter-list">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, false)">
                <span class="el-dropdown-link">
                  发表时间<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in pubDate" :key="index"
                    :command="{ value: item, name: 'pubDate' }">
                    <span v-if="item === '全部'">{{ item }}</span>
                    <span v-else-if="item !== '全部'">近{{ item }}年</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                <span class="el-dropdown-link">
                  影响因子<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in impFct" :key="index"
                    :command="{ value: item, name: 'impFct' }">{{ item }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list" v-if="allDiseasesConditionsList.length > 0">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer;" @command="handleCommand($event, true)">
                <span class="el-dropdown-link">
                  疾病与人群<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 350px;">
                  <el-input
                    v-model="disease"
                    style="width: 95%;display: block;margin: 0 auto; margin-bottom: 10px;"
                    size="small"
                    placeholder="请输入内容"
                    suffix-icon="el-icon-search"
                    clearfix>
                  </el-input>
                  <el-dropdown-item v-for="(item, index) in diseasesConditionsList" :key="index"
                    :command="{ value: item, name: 'diseasesConditions' }">
                    <span>{{ item }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list" v-if="allInterventionsList.length > 0">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                <span class="el-dropdown-link">
                  干预与操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 350px;">
                  <el-input
                    v-model="intervention"
                    style="width: 95%;display: block;margin: 0 auto; margin-bottom: 10px;"
                    size="small"
                    placeholder="请输入内容"
                    suffix-icon="el-icon-search"
                    clearfix>
                  </el-input>
                  <el-dropdown-item v-for="(item, index) in interventionsList" :key="index"
                    :command="{ value: item, name: 'interventions' }">
                    <span>{{ item }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list" v-if="allGeographicalRegionsList.length > 0">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                <span class="el-dropdown-link">
                  国家与地区<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 350px;">
                  <el-input
                    v-model="geographicalRegion"
                    style="width: 95%;display: block;margin: 0 auto; margin-bottom: 10px;"
                    size="small"
                    placeholder="请输入内容"
                    suffix-icon="el-icon-search"
                    clearfix>
                  </el-input>
                  <el-dropdown-item v-for="(item, index) in geographicalRegionsList" :key="index"
                    :command="{ value: item, name: 'geographicalRegions' }">
                    <span>{{ item }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list">
              <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, false)">
                <span class="el-dropdown-link">
                  性别<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in genderList" :key="index"
                    :command="{ value: item.name, name: 'gender' }">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="filter-list age-box">
              <span class="el-dropdown-link">年龄：</span>
              <div class="age-input">
                <el-input size="small" type="number" v-model="startAge" @input="handleSetAge"></el-input>
                <span class="split-line"></span>
                <el-input size="small" type="number" v-model="endAge" @input="handleSetAge"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="tags">
          <el-row>
            <el-col :span="20">
              <el-tag
                closable
                v-for="(tag, tagIndex) in tags"
                :key="tagIndex"
                @close="closeTags(tag, tagIndex)"
              >
                {{ tag }}
              </el-tag>
            </el-col>
            <el-col :span="4" class="clearBtn" v-if="tags.length !== 0">
              <img src="../assets/img/clear.png" alt="" />
              <el-link type="primary" @click="clearFilter">清空筛选条件</el-link>
            </el-col>
          </el-row>
        </div>
        <div class="resultList" v-loading.fullscreen="loading" element-loading-text="拼命加载中" v-show="hasData">
          <ul>
            <li v-for="(item, index) in searchData" :key="item.pmid + '-' + index" v-loading="item.loading">
              <h3>
                <span>{{ !item.translate ? item.title_en : item.title_cn }}</span>
                <!-- <img src="../assets/img/ppt.png" alt=""> -->
                <em v-if="item.impact_factor">
                  <img src="../assets/img/icon6.png" alt="" class="L" />影响因子：{{ item.impact_factor }}
                </em>
              </h3>
              <div class="important-message">
                <span class="qikan"><em>期刊：</em>{{ item.journal_name }}</span>
                <span><em>PMID：</em>{{ item.pmid }}</span>
                <span><em>发表时间：</em>{{ item.pubdate }}</span>
              </div>
              <div class="userInfo">
                <el-avatar :size="48" :src="item.avatar"></el-avatar>
                <p class="info-box">
                  <span><em class="pat-code">患者编号：</em>{{ item.patient_uid }}</span>
                  <span class="gender ">{{ item.gender ? '男' : '女' }} {{ item.age }}岁</span>
                </p>
              </div>
              <div class="listInfo">
                <!-- 疾病与人群 -->
                <p class="info-detail" v-if="item.keywords && item.keywords['Diseases & conditions'].length > 0">
                  <span>疾病与人群：</span>
                  <template v-if="!item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                  <template v-if="item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                </p>
                <!-- 干预与操作 -->
                <p class="info-detail" v-if="item.keywords && item.keywords['Interventions'].length > 0">
                  <span>干预与操作：</span>
                  <template v-if="!item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                  <template v-if="item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                </p>
                <!-- 国家与地区 -->
                <p class="info-detail" v-if="item.keywords && item.keywords['Geographical regions'].length > 0">
                  <span>国家与地区：</span>
                  <template v-if="!item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                  <template v-if="item.translate">
                    <em v-for="(words, wordsIndex) in item.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
                  </template>
                </p>
                <p class="info-detail" :class="item.key_height">
                  <span>疾病介绍：</span><em v-html="!item.translate ? item.patient_en : item.patient_cn"></em>
                </p>
                <p class="down" :class="item.key_height === 'initHeight' ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                  @click="showFull(item.key_height, index)"></p>
              </div>
              <div class="actionBox">
                <a href="javascript:;" @click="translateFullText(index)"><img src="../assets/img/icon14.png" alt="">翻译</a>
                <a href="javascript:;" @click="showCaseDetail(item)">
                  <img src="../assets/img/icon15.png" alt="">
                  查看详情
                </a>
                <a href="javascript:;" @click="collection(item, index)">
                  <img src="../assets/img/icon3-2.png" alt="" v-if="!item.is_collected">
                  <img src="../assets/img/icon3-3.png" alt="" v-if="item.is_collected">
                  {{ item.is_collected ? '已收藏' : '收藏' }}
                </a>
                <a href="javascript:;" @click="showFullText(item)"><img src="../assets/img/icon8-2.png" alt="">源文献</a>
                <a href="javascript:;" @click="showSimilarCase(item)"><img src="../assets/img/icon9-2.png" alt="">相似病例</a>
              </div>
            </li>
          </ul>
        </div>
        <el-pagination v-show="isShow" background :hide-on-single-page="true" :current-page="pageNum"
          :page-size="pageSize" @current-change="handleCurrentChange" layout="prev, pager, next" :total="totalNum">
        </el-pagination>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，重新搜搜看看吧~</span>
      </div>
    </div>
  </div>
</template>
<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import {
  caseSearchSuggest,
  caseSearch,
  getFilters,
  caseCollect,
  caseTranslate,
  translateInfo
} from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "caseList",
  components: {
    viewHeader,
  },
  data() {
    return {
      hasData: true, // 是否有数据
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true, // 页面加载动画
      keyword: "", // 搜索的关键字
      searchData: [], // 搜索出的文献数据
      pageNum: 1, // 当前页
      pageSize: 10, // 每页数量
      totalNum: 0, // 搜索出的总数
      isShow: false,
      pubType: [], // 文献类型
      pubDate: [], // 发表时间
      impFct: [], // 影响因子
      sort: [], // 相关性排序
      manual: false, // 是否是人工标注
      filter: {
        // pubType: "",
        pubDate: [],
        impFct: [],
        manual: "",
        gender: [],
        age: []
      }, // 筛选条件
      sortText: "相关性从高到低",
      titleJson: {},
      importantJson: {}, // 重点信息
      advance: false, // 是否是精准搜索
      tags: [], // 过滤条件
      tagsJson: {},
      preNumFound: 1, //如果为0，提示用户没找到相关文献，并推荐其他文献
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      // diseaseTypeValue: '疾病与人群',
      // diseaseType: ['疾病与人群', '干预与操作', '国家与地区'],
      genderList: [
        { 'name': '全部', 'value': 'all' },
        { 'name': '男', 'value': '1' },
        { 'name': '女', 'value': '0' },
      ],
      startAge: '',
      endAge: '',
      diseaseWords: [], // 需过滤的关键字集合（疾病与人群，干预与操作，国家与地区的内容）
      diseasesConditionsList: [], // 当前的疾病与人群
      interventionsList: [], // 当前的干预与操作
      geographicalRegionsList: [], // 当前的国家与地区
      allDiseasesConditionsList: [], // 疾病与人群
      allInterventionsList: [], // 干预与操作
      allGeographicalRegionsList: [], // 国家与地区
      // diseaseWordsList: [],
      disease: '',
      intervention: '',
      geographicalRegion: '',
      currentPageUrl: '', // 当前页面url
      searchType: ''
    };
  },
  watch: {
    disease() {
      if (this.disease.trim() == '') {
        this.diseasesConditionsList = this.allDiseasesConditionsList;
        return
      };
      this.getDefaultDiseaseWords('疾病与人群', this.disease).then(res => {
        this.diseasesConditionsList = res;
      })
    },
    intervention() {
      if (this.intervention.trim() == '') {
        this.interventionsList = this.allInterventionsList;
        return
      };
      this.getDefaultDiseaseWords('干预与操作', this.intervention).then(res => {
        this.interventionsList = res;
      })
    },
    geographicalRegion() {
      if (this.geographicalRegion.trim() == '') {
        this.geographicalRegionsList = this.allGeographicalRegionsList;
        return
      };
      this.getDefaultDiseaseWords('国家与地区', this.geographicalRegion).then(res => {
        this.geographicalRegionsList = res;
      })
    }
  },
  methods: {
    // handleSelectWords() {
    //   if (this.diseaseWords.length == 0) {
    //     this.getDefaultDiseaseWords();
    //     this.loading = true;
    //     this.normalSearch()
    //   } else {
    //     this.loading = true;
    //     this.normalSearch()
    //   }
    // },
    // 修改疾病关键字类型
    // handleChangeDiseaseType(data) {
    //   this.diseaseTypeValue = data;
    //   this.diseaseWords = [];
    //   this.getDefaultDiseaseWords();
    //   this.normalSearch();
    // },
    // 获取病例疾病关键字
    // async getDiseaseWords(data) {
    //   if (data == '') return;
    //   this.diseaseWordsList = [];
    //   let params = {
    //     select: data,
    //     type: this.diseaseTypeValue
    //   }
    //   let res = await caseSearchSuggest(params);
    //   if (res && res.data.status == 0) {
    //     this.diseaseWordsList = res.data.data;
    //   } else {
    //     this.diseaseWordsList = []
    //   }
    // },
    // 获取疾病与人群、干预与操作、国家与地区关键字
    async getDefaultDiseaseWords(keywords, searchKey = '') {
      // this.diseaseWordsList = [];
      let params = {
        select: searchKey,
        type: keywords
      }
      let res = await caseSearchSuggest(params);
      if (res && res.data.status == 0) {
        return res.data.data;
      } else {
        return []
      }
    },
    // 设置年龄
    handleSetAge() {
      // 起始年龄和截止年龄都非空，则年龄值为 起始年龄-截止年龄（50-60）
      // 当起始年龄为空，截止年龄非空，则年龄值为<=截止年龄（>=60）
      // 当截至年龄为空，起始年龄非空，则年龄值为>=起始年龄(<=30)
      if ((this.startAge == '' || this.startAge < 0) && (this.endAge == '' || this.endAge < 0)) {
        this.startAge = '';
        this.endAge = '';
        this.filter['age'] = [];
      }
      if ((this.startAge != '' && this.startAge > 0) && (this.endAge != '' && this.endAge > 0)) {
        this.filter['age'] = [this.startAge + '-' + this.endAge]
      }
      if ((this.startAge != '' && this.startAge > 0) && (this.endAge == '' || this.endAge < 0)) {
        this.endAge = '';
        this.filter['age'] = ['>=' + this.startAge]
      }
      if ((this.endAge != '' && this.endAge > 0) && (this.startAge == '' || this.startAge < 0)) {
        this.startAge = '';
        this.filter['age'] = ['<=' + this.endAge]
      }

      this.tags = [];
      if (this.filter['age'].length > 0) {
        this.tagsJson['age'] = this.filter['age'];
      } else {
        delete this.tagsJson['age']
      }

      for (const name in this.tagsJson) {
        if (this.tagsJson[name] != '') {
          this.tags.push(...this.tagsJson[name]);
        }
      }
      this.normalSearch();
    },
    // 获取病例搜索的文献结果
    async normalSearch(keyword = '') {
      this.loading = true;
      this.keyword = keyword || this.keyword;
      const params = {
        keyword: keyword || this.keyword,
        pages: { limit: this.pageSize, page: this.pageNum },
        filters: {
          pubDate: this.filter.pubDate[0] || '',
          impFct: this.filter.impFct.join('|'),
          manual: this.filter.manual,
          age: this.filter.age.join('|'),
          gender: this.filter.gender.join('|')
        },
        sort: this.sortText,
        scope: this.diseaseWords
      };
      let Logger = webTrackerEvent();
      let res = await caseSearch(params);
      Logger.push("eventType", "search");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("searchType", 'caseReport');
      Logger.push("searchText", keyword || this.keyword);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.push("pageUrl", window.location.href);
      Logger.logger();

      if (res && res.data.status === 0) {
        this.isShow = true;
        this.loading = false;
        this.totalNum = res.data.numFound;
        this.preNumFound = res.data.pre_numFound;
        if (res.data.data.length === 0) {
          this.hasData = false;
          return;
        }
        this.hasData = true;
        res.data.data.forEach((item, index) => {
          item.patient_en = item.patient_en.replace(/\n/g, '<br/>');
          // item.patient_cn = item.patient_cn.replace(/\n/g, '<br/>');
          item.patient_cn = "";
          if (item.pubdate_show) {
            // item.pubdate_show = item.pubdate_show.substring(0, 10);
            item.loading = false;
          }
          if (item.gender) {
            item.avatar = require('../assets/img/female.png')
          } else {
            item.avatar = require('../assets/img/male.png')
          }
          item.key_height = "initHeight";
          item.translate = false;
        });
        this.searchData = res.data.data;
      } else {
        this.isShow = true;
        this.loading = false;
        this.hasData = false;
      }
    },
    // 获取筛选条件
    async getFilterOpt() {
      const res = await getFilters();
      if (res && res.data.status === 0) {
        this.pubType = ["全部", ...res.data.data.pubType];
        this.pubDate = ["全部", ...res.data.data.pubDate];
        this.impFct = ["全部", ...res.data.data.impFct];
        this.sort = res.data.data.sort;
      }
    },
    // 筛选条件
    handleCommand(command, multiple) {
      const {value,name} = command;
      const selectedList = this.tagsJson[name];
      if(selectedList) {
        const isExist = selectedList.find(item => item == value);
        if(isExist) {
          return;
        }
      } else if(value == '全部') {
        return;
      }

      // 修改过滤条件
      if (command.value === "全部") {
        this.filter[command.name] = [];
      } else if (command.name === "gender") {
        this.genderList.filter(item => {
          if (item.name == command.value) {
            if(multiple) {
              this.filter[command.name].push(item.value);
            } else {
              this.filter[command.name] = [item.value];
            }
          }
        })
      } else if (command.name === "diseasesConditions" || command.name == "interventions" || command.name == "geographicalRegions") {
        this.diseaseWords.push(command.value);
      } else {
        if(multiple) {
          this.filter[command.name].push(command.value);
        } else {
          this.filter[command.name] = [command.value];
        }
      }

      // 获取过滤条件 标签显示
      if (command.name === "pubDate") {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push("近" + command.value + "年") : this.tagsJson[command.name] = ["近" + command.value + "年"];
          } else {
            this.tagsJson[command.name] = ["近" + command.value + "年"];
          }
        } else {
          delete this.tagsJson["pubDate"];
        }
      } else if (command.name === "gender") {
        if (command.value !== "全部") {
          this.genderList.filter(item => {
            if (item.name == command.value) {
              if (multiple) {
                this.tagsJson[command.name] ? this.tagsJson[command.name].push(command.value) : this.tagsJson[command.name] = [command.value];
              } else {
                this.tagsJson[command.name] = [command.value];
              }
            }
          })
        } else {
          delete this.tagsJson["gender"];
        }
      } else {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push(command.value) : this.tagsJson[command.name] = [command.value];
          } else {
            this.tagsJson[command.name] = [command.value];
          }
        } else {
          delete this.tagsJson[command.name];
        }
      }
      this.tags = [];
      for (const name in this.tagsJson) {
        this.tags.push(...this.tagsJson[name]);
      }
      this.showTags = true;
      // this.isShow = false
      // this.loading = true;
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 关闭标签
    closeTags(tag, tagIndex) {
      for (const name in this.tagsJson) {
        const selectedList = this.tagsJson[name];
        const index = selectedList.findIndex(item => item == tag);
        if(index > -1) {
          selectedList.splice(index,1);
          if (name == 'diseasesConditions' || name == 'interventions' || name == 'geographicalRegions') {
            const filterIndex = this.diseaseWords.findIndex(item => {
              return item == tag;
            });
            if(filterIndex > -1) {
              this.diseaseWords.splice(filterIndex,1);
            }
            break;
          }

          const filterIndex = this.filter[name].findIndex(item => {
            if(name == 'pubDate') {
              return `近${item}年` == tag;
            } else if (name == 'gender') {
              let genderText = '';
              item == 1 ? genderText = '男' : genderText = '女';
              return genderText = tag
            } else {
              return item == tag;
            }
          });
          if(filterIndex > -1) {
            this.filter[name].splice(filterIndex,1);
          }
          break;
        }
      }
      this.tags.splice(tagIndex, 1);
      if (this.tags.length === 0) {
        this.tagsJson = {};
      }
      this.loading = true;
      this.pageNum = 1;
      this.normalSearch();
    },
    // 清除筛选条件
    clearFilter() {
      this.tags = [];
      this.tagsJson = {};
      // this.filter["pubType"] = "";
      this.filter["pubDate"] = [];
      this.filter["impFct"] = [];
      this.filter["gender"] = [];
      this.filter["age"] = [];
      this.startAge = "";
      this.endAge = "";
      this.diseaseWords = [];
      this.pageNum = 1;
      this.normalSearch();
    },
    // 排序条件
    handleCommandSort(val) {
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 选择人工标注
    change(val) {
      if (val) {
        this.filter["manual"] = 1;
      } else {
        this.filter["manual"] = "";
      }
      // this.isShow = false
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 翻译重点信息
    async translateFullText(index) {
      let currentData = this.searchData[index];
      const { patient_uid, pmid, patient_cn, title_cn } = currentData;
      if (currentData.translate) {
        currentData.translate = false
      } else {
        if(patient_cn && title_cn) {
          currentData.translate = true
        } else {
          currentData.loading = true;
          // 翻译patient_cn
          const params1 = {
            patient_uid
          }
          // 翻译title_cn
          let ts = new Date().getTime();
          let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
          let token = md5(tokenStr, 32);
          const params2 = {
            client_id: this.clientId,
            ts: Number(ts),
            pmid: String(pmid),
            types: "cn_key",
            token: token,
          };
          const [result1, result2] = await Promise.all([caseTranslate(params1), translateInfo(params2)]).catch(res => {
            currentData.loading = false;
          });
          currentData.loading = false;
          if(result1 && result1.data && result1.data.status == 0) {
            const { patient_cn } = result1.data.data;
            currentData.patient_cn = patient_cn;
          }
          if(result2 && result2.data && result2.data.status == 0) {
            const { title } = result2.data.data;
            currentData.title_cn = title;
          }
          currentData.translate = true
        }
      }
      this.$set(this.searchData, index, currentData)
    },
    // 展开全文
    showFull(key_height, index) {
      if (key_height === "initHeight") {
        this.searchData[index]["key_height"] = "autoHeight";
      } else {
        this.searchData[index]["key_height"] = "initHeight";
      }
    },
    // 收藏还是取消收藏
    collection(data, index) {
      if (!data.is_collected) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "collection_case");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", data.patient_uid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("pmid", data.pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        caseCollect("POST", { patient_uid: data.patient_uid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = true;
          } else {
            this.$message({
              message: "收藏失败，请重试",
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "cancel_collection_case");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", data.patient_uid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("pmid", data.pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        caseCollect("DELETE", { patient_uid: data.patient_uid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = false;
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      // this.isShow = false
      // this.searchData = []
      this.pageNum = val;
      window.scroll(0, 0);
      this.normalSearch();
    },
    // 查看源文献
    showFullText(data) {
      let Logger = webTrackerEvent();
      Logger.push("eventType", "caseReportItem_click");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("pmid", data.pmid);
      Logger.push("pageUrl", window.location.href);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "fullText",
        path: "/fullText",
        query: {
          pmid: data.pmid
        },
      });
      window.open(href);
    },
    // 查看全文
    showCaseDetail(data) {
      let Logger = webTrackerEvent();
      Logger.push("eventType", "caseReportItem_viewDetail");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("patientUid", data.patient_uid);
      Logger.push("pmid", data.pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.push("pageUrl", window.location.href);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "caseDetail",
        path: "/caseDetail",
        query: {
          patientUid: data.patient_uid,
          pmid: data.pmid,
          searchType: this.searchType
        },
      });
      window.open(href);
      // this.$router.push("fullText?pmid=" + pmid);
    },
    // 查看相似病例
    showSimilarCase(data) {
      let Logger = webTrackerEvent();
      Logger.push("eventType", "viewSimilarCase");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("pmid", data.pmid);
      Logger.push("patient_uid", data.patient_uid);
      Logger.push("pageUrl", window.location.href);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "similarCase",
        path: "/similarCase",
        query: {
          pmid: data.pmid,
          patientUid: data.patient_uid,
          searchType: this.searchType
        },
      });
      window.open(href);
    },
    // 文献总结
    analysis() {
      const { href } = this.$router.resolve({
        name: "caseAnalysis",
        path: "/caseAnalysis",
        query: {
          key: this.keyword,
          numFound: this.totalNum,
          filter: JSON.stringify({
            pubDate: this.filter.pubDate[0] || '',
            impFct: this.filter.impFct.join('|'),
            manual: this.filter.manual,
            age: this.filter.age.join('|'),
            gender: this.filter.gender.join('|')
          }),
          sort: this.sortText,
          scope: JSON.stringify(this.diseaseWords),
          searchType: this.searchType
        },
      });
      window.open(href);
    },
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  created () {
    this.advance = this.$route.query.advance;
    this.keyword = this.$route.query.key;
    this.searchType = this.$route.query.searchType;

    this.currentPageUrl = window.location.href;
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();
    // this.title_word = this.keyword;
    // if (this.advance && this.advance === "advance") {
    //   if (typeof this.keyword === "object") {
    //     this.title_word = this.keyword.join(" ");
    //   } else {
    //     this.keyword = [this.keyword];
    //   }
    // }
    this.getDefaultDiseaseWords('疾病与人群').then(res => {
      this.diseasesConditionsList = res
      this.allDiseasesConditionsList = res
    });
    this.getDefaultDiseaseWords('干预与操作').then(res => {
      this.interventionsList = res
      this.allInterventionsList = res
    });
    this.getDefaultDiseaseWords('国家与地区').then(res => {
      this.geographicalRegionsList = res
      this.allGeographicalRegionsList = res
    });
    this.normalSearch();
    this.getFilterOpt();
  },
};
</script>
<style>
/* 隐藏数字输入框后边的按钮 */
/* 谷歌 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

/* 火狐 */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style scoped lang="less">
.caseList {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}

.caseList .content {
  width: 1080px;
  margin: 0 auto;

  .filter-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;

    .filter-list {
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
  }

  /deep/.age-box {
    display: flex;
    align-items: center;
    color: #606266;

    .age-input {
      display: flex;
      align-items: center;
      // width: 100px;
    }

    .el-input {
      width: 65px;
      margin: 0 2px;

      input {
        padding: 0;
        text-align: center;
      }
    }

    .split-line {
      width: 8px;
      height: 1px;
      background: #666;
      margin: 0 3px;
    }
  }

  /deep/.disease-keywords-box {
    display: flex;
    align-items: center;
    color: #606266;

    .keywords-box {
      border: 1px solid #DCDFE6;
      border-radius: 4px;
    }

    .filterKeyWord {
      background: #3491FA;
      color: #fff;
      font-size: 12px;
      height: 32px;
      padding: 0 14px;
      margin-left: 3px;
    }

    .el-select {
      input {
        border: none;
      }

      .el-tag {
        max-width: 98%;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &.search-select {
        width: 250px;
      }
    }

    .type-select {
      width: 110px !important;
      border-right: 1px solid #DCDFE6;
    }
  }
}

.caseList .content .header-box {
  display: flex;
  align-items: center;
}

.caseList .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  flex: 1;
  /* margin-top:4px; */
}

.caseList .content .el-card__header button {
  padding: 10px 20px !important;
  border: 1px solid #409eff;
}

.caseList .content .resultTtle {
  font-size: 14px;
  color: #333;
}

.caseList .content .resultTtle .pointData {
  font-size: 12px;
  color: #eb7400;
  margin-bottom: 5px;
}
.caseList .content .resultTtle .totalnum-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.caseList .content .resultTtle .el-col {
  padding: 0;
}

.caseList .content .resultTtle .num .el-col {
  padding: 0;
}

.caseList .content .resultTtle span.sort_sp {
  line-height: 32px;
  // margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.caseList .content .resultTtle .el-select {
  width: 150px;
  line-height: 32px;
}

.caseList .content .tags {
  margin-top: 20px;
}

.caseList .content .tags em {
  font-size: 12px;
  color: #6098db;
}

.caseList .content .tags span {
  margin: 0 10px 10px 0;
}

.caseList .content .tags .clearBtn {
  line-height: 32px;
  display: flex;
  justify-content: flex-end;
}

.caseList .content .tags .clearBtn img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 10px;
  margin-top: 6px;
}

.caseList .content .resultList {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-bottom: none;
}

.caseList .content .resultList ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  position: relative;
  overflow: hidden;

  h3 {
    display: flex;
    justify-content: space-between;
    font-weight: normal;
    // align-items: center;
    span {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      max-width: 80%;
      // word-break: break-all;
    }

    img {
      width: 20px;
      height: 20px;
    }

    em {
      text-align: right;
      margin-right: 60px;
      font-size: 14px;
      display: flex;
      align-items: center;
      img{
        width: 17px;
        height: 17px;
        margin-right: 10px;
      }
    }
  }

  .important-message {
    font-size: 14px;
    margin: 10px 0;
    color: #333;
    display: flex;

    span {
      em {
        color: #387ed2;
      }

      margin-right: 40px;

      &.qikan {
        width: 60%;
      }
    }
  }

  .userInfo {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;

    .info-box {
      display: flex;
      flex-direction: column;
      margin-left: 10px;

      .pat-code {
        color: #387ed2;
      }

      .gender {
        margin-top: 10px;
      }
    }
  }

  .listInfo {
    p.info-detail {
      font-size: 14px;
      color: #333;
      margin-bottom: 10px;
      line-height: 22px;

      span {
        color: #387ed2;
      }

      &.initHeight {
        overflow: hidden;
        /*将对象作为弹性伸缩盒子模型显示*/
        display: -webkit-box;
        /*设置子元素排列方式*/
        -webkit-box-orient: vertical;
        /*设置显示的行数，多出的部分会显示为...*/
        -webkit-line-clamp: 3;
      }

      &.autoHeight {
        display: block;
      }
    }

    .down {
      font-size: 24px;
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
    }
  }

  .actionBox {
    display: flex;
    align-items: center;

    a {
      display: flex;
      align-items: center;
      margin-right: 40px;

      img {
        margin-right: 8px;
        width: 30px;
      }
    }
  }
}

.caseList .content .el-pagination {
  margin-top: 30px;
  text-align: center;
}

.caseList .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}

.caseList .noData img {
  display: block;
  margin: 0 auto;
}

.caseList .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}

/deep/.el-dropdown-menu{
  width: 350px !important;
}
/* .caseList .content .resultList .action a img{
  width: 18px;
  height: 18px;
  display: block;
  margin: 0 auto;
}
.caseList .content .resultList .action a img.fullText{
  width: 20px;
} */
</style>


// WEBPACK FOOTER //
// src/views/caseList.vue